import React, { useEffect, useState } from "react";
import "../HomeWork.css";
import AllQuestions from "../OnReview/QuestionTypes/AllQuestions";
import { useSelector } from "react-redux";
import moment from "moment";
import axios from "../../../axios";
import FilterNotFound from "../Filter_Box/FilterNotFound";
import { SubjectIcon } from "../../../SubjectIcon";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { BookText, CalendarDays } from "lucide-react";
import { shortenParagraph } from "../../../utils/Engagement";

export default function OnReview({ filter }) {
  const [onReview, setOnReview] = useState({
    homeworkId: null,
    questionReview: false,
  });
  const navigate = useNavigate();
  const [reviewCard, setReviewCard] = useState([]);
  const currentUser = useSelector((state) => state.user.currentUser);
  const [isGettingData, setIsGettingData] = useState(true);
  const [noContentClick, setNoContentClick] = useState(false);

  useEffect(() => {
    const reviewBox = async () => {
      try {
        let response = await axios.get(
          `/homework/filterByStudentId/${currentUser?.id}/review?_page=${filter?.page}&_limit=${filter?.limit}&sortBy=${filter?.sortBy}` +
            `${
              filter?.date
                ? `&date=${moment(filter?.date).format("YYYY-MM-DD")}`
                : ``
            }` +
            `${filter?.time ? `&time=${filter?.time}` : ``}` +
            `${
              filter?.subjectId?.length !== 0
                ? `&subjectId=${filter?.subjectId}`
                : ``
            }`
        );

        response && setReviewCard(response.data.data);
        setIsGettingData(false);
      } catch (error) {
        console.log(error);
      }
    };
    reviewBox();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate().toString().padStart(2, "0");
    const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, "0");
    const year = dateObj.getUTCFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };

  const handleQuestionfalse = () => {
    setOnReview({
      ...onReview,
      questionReview: false,
    });
  };

  return (
    <div>
      {reviewCard && reviewCard.length > 0 ? (
        <div>
          <div className="d-flex gap-4 mt-3 flex-wrap">
            {reviewCard?.map((item, index) => (
              // <div
              //   className="containerForPendinDeatail p-3 "
              //   onClick={(e) => {
              //     setOnReview({
              //       ...onReview,
              //       questionReview: true,
              //       homeworkId: item?.id,
              //     });
              //   }}
              //   key={index}
              // >
              //   <div className="kannadaHeader">{item?.subject_id?.name}</div>
              //   <div className="headingOfHW mt-2" >{item?.name}</div>
              //   <span className="deadline">Submitted</span> &nbsp;
              //   <span className="deadlineDate">
              //     {timeHelper(item?.submitted_on)}
              //   </span>
              // </div>
              <div
                key={index}
                // className="summarySubBoxContainerHW"
                className="w-80 h-32 d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4 cursor-pointer card_style"
                style={{
                  borderTop: `8px solid #${item?.subject_id?.subject_color}`,
                }}
                onClick={(e) => {
                  // setOnReview({
                  //   ...onReview,
                  //   questionReview: true,
                  //   homeworkId: item?.id,
                  // });
                  navigate(`/reviewHomework`, {
                    state: { homeworkId: item?.id },
                  });
                }}
              >
                <div
                  className="d-flex SubsummarySubBoxContainer justify-content-between align-items-center"
                  // style={{
                  //   borderTop: `10px solid #${item?.subject_id?.subject_color}`,
                  //   paddingBottom: "0",
                  // }}
                >
                  <div>
                    <div className="subboxSubjectName">
                      {item?.subject_id?.name}
                    </div>
                  </div>
                  <div>
                    <img
                      src={`${
                        SubjectIcon?.find(
                          (i) => i.subjectName === item?.subject_id?.name
                        )?.icon
                      }`}
                      alt=""
                    />
                  </div>
                </div>
                <div
                  className="SubsummarySubBoxContainer"
                  style={{ paddingTop: "0" }}
                >
                  <div className="headingOfHW" title={item?.name}>
                    <Tooltip
                      title={item?.name}
                      arrow
                      placement="bottom"
                      enterDelay={200}
                      leaveDelay={100}
                    >
                      <span className="sbj flex">
                        <BookText size={16} className="me-2 mt-1 text-dark" />
                        {shortenParagraph(item?.name, 30)}
                      </span>
                    </Tooltip>
                  </div>
                  <div className="flex mt-2">
                    <CalendarDays size={16} className="me-2 text-dark" />
                    <span className="deadline">Submitted: </span> &nbsp;
                    <span className="deadlineDate">
                      {timeHelper(item?.submitted_on)}{" "}
                    </span>
                  </div>
                  <span
                    style={{
                      color: "#FF0000",
                      fontSize: "16px",
                      fontWeight: "600",
                      textAlign: "right",
                      display: "block",
                    }}
                  >
                    {moment(item?.deadline).format("YYYY-MM-DD") <
                    moment(item?.submitted_on).format("YYYY-MM-DD")
                      ? "Delayed Submission"
                      : " "}
                  </span>
                </div>
              </div>
            ))}
          </div>
          {/* 
          {onReview.questionReview && (
            <AllQuestions
              handleQuestionfalse={handleQuestionfalse}
              homeworkId={onReview?.homeworkId}
            />
          )} */}
        </div>
      ) : isGettingData ? (
        <img className="ongoing_loader" src="/gif/LoaderDot.gif" alt="" />
      ) : (
        <div className="d-flex justify-content-center h-20 align-items-center w-100">
          <span
            className="px-2 py-2 d-flex align-items-center gap-2"
            style={{ fontSize: "1.2rem", fontWeight: 500 }}
          >
            ✏️ Homework Not Found
          </span>
        </div>
      )}
    </div>
  );
}
